var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resolvedLogoUrl && !_vm.loadFailed)?_c('img',{staticClass:"airline-logo",style:(_vm.logoStyle),attrs:{"src":_vm.resolvedLogoUrl,"alt":""},on:{"error":function($event){_vm.loadFailed = true}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }